export default __webpack_public_path__ + "static/media/news40.d53c3cc0.jpg";